let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("l4q1r"), load("h4u0O")]).then(() => parcelRequire('95zUF'));